@if (viewModel) {
    <div class="greyhound-participant-container">
        <ul>
            <ms-greyhounds-resulted-placed-participants
                class="clearfix"
                [participants]="viewModel.placed"
                [prices]="prices"
                [placeTermValue]="placeTerms"
                [isOptionBet]="fixture.isOptionBet"
                [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                [participantOptionGroups]="viewModel.participantOptionGroups"
                [fixture]="fixture">
            </ms-greyhounds-resulted-placed-participants>
            <ms-greyhounds-resulted-placed-participants
                class="clearfix"
                [participants]="viewModel.favorites"
                [isFavourites]="true"
                [prices]="prices"
                [placeTermValue]="placeTerms"
                [isOptionBet]="fixture.isOptionBet"
                [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                [participantOptionGroups]="viewModel.participantOptionGroups"
                [fixture]="fixture">
            </ms-greyhounds-resulted-placed-participants>
        </ul>
        @if (viewModel.nonRunners.length) {
            <ms-resulted-greyhounds-non-runner-participants
                [fixtureParticipants]="fixture.participants"
                [participants]="viewModel.nonRunners"
                [isOptionBet]="fixture.isOptionBet" />
        }
    </div>
    <div class="greyhounds-dividend-wrapper">
        <div class="greyhounds-dividend-header-container bet-type-header">
            <div class="greyhounds-bettype-left">{{ sitecore.horseRacing.raceResulted.BetType }}</div>
            <div class="greyhounds-bettype-right">
                <div class="greyhounds-bettype-result">{{ sitecore.horseRacing.badges.Resulted }}</div>
                <div class="greyhounds-bettype-dividend">{{ sitecore.horseRacing.raceResulted.Dividend }}</div>
            </div>
        </div>
        <div class="greyhounds-row-dividend-container">
            @for (dividend of viewModel.dividends; track dividend) {
                <div class="greyhounds-dividend-header-container greyhounds-row-dividend">
                    <div class="greyhounds-bettype-left greyhounds-left-row">{{ dividend.name }}</div>
                    <div class="greyhounds-bettype-right">
                        <div class="greyhounds-bettype-result">{{ dividend.result || '-' }}</div>
                        @if (dividend.available) {
                            <div class="greyhounds-bettype-dividend">{{ dividend.value || '-' }}</div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
